import styled from "styled-components";

type ContainerProps = { $gap?: string };

export const Container = styled.div<ContainerProps>`
  ${({ $gap = "8px" }) => `
    display: grid;
    justify-items: start;
    gap: ${$gap};
  `}
`;
